<template>
  <v-tab>
    <v-icon left>
      {{ icon }}
    </v-icon>
    {{ text }}
  </v-tab>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
  }
};
</script>
